// noinspection JSIgnoredPromiseFromCall
import { useState, useRef} from 'react'
import { SLowcodeList, STableActions, SActionBtn } from 'shj-components'
import config from './config'
import { message } from 'antd';
import _ from 'lodash-es';
import { useNavigate } from 'react-router-dom'
// import { getDataDictionaries, getlaunchPlatformList, launchPlatformDel } from '@/services/getUsers'
import type { EnumDescription } from '@/pages/clueConfig/launchPlatform/interface';
import LaunchPlatformPageModify from './modify'
export default function ListPage() {
  const listRef = useRef<any>();
  const [open, setOpen] = useState(false)
  const [id, setId] = useState('')
  const history = useNavigate()
  const [platformTypeMap, setPlatformTypeMap] = useState<Record<string, string>>({});

  // 获取下拉
  const getSelection = () => {
    return new Promise(async (resolve) => {
        // let platformTypes:EnumDescription[] =  await getDataDictionaries('com.shj.saas.clue.domain.account.enums.PlatformTypeEnum')
        let platformTypes:EnumDescription[] =  []
        const typeMap = {};
          platformTypes.forEach((type) => (typeMap[type.key] = type.value));
          setPlatformTypeMap(typeMap);
        resolve({
          platformTypes: platformTypes,
        });
      });
  };

  const fetchList = (values: { current: number; pageSize: number; query: Record<string, any> }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const { current, pageSize, query } = values;
        // getlaunchPlatformList(current, pageSize, query).then(data => resolve(data))
        resolve({})
      } catch (e) {
        reject({ success: false });
      }
    });
  };

  // 刷新
  const reloadFn = () => {
    const {
      current: { reload },
    } = listRef;
    reload();
  };

  const onAdd = () => {
    // history('/getUsersConfig/launchPlatform/add');
    setId('')
    setOpen(true)
  }

  const onEdit = (record) => {
    // history(`/getUsersConfig/launchPlatform/update/${record.id}`);
    setId(record.id)
    setOpen(true)
  }
  const onDel = ({ id }: { id: number }) => {
    // launchPlatformDel(id).then((resp: any) => {
    //     message.success(resp?.message);
    //     reloadFn();
    //   })
    //   .catch(() => {});
  };

  const extension = {
    request: { fetchList, getSelection },
    events: { onAdd },
    customRender: {
      platformTypesRender(types: string) {
        if(types){
          let typesList = JSON.parse(types)
          return typesList.map((type) => platformTypeMap[type]).join(';');
        }else{
          return ''
        }
      },
      actionTool(text: any, record: any) {
        return (
          <div style={{ display: 'flex', justifyContent: 'space-around' }}>
            <STableActions>
              <SActionBtn onClick={() => onEdit(record)}>
                编辑
              </SActionBtn>
              <SActionBtn title="确认删除该投放平台?" danger confirm  onClick={() => onDel(record)} oktext="确认" canceltext="取消">
                删除
              </SActionBtn>
            </STableActions>
          </div>
        );
      },
    },
  };

  return <>
    <SLowcodeList config={config} ref={listRef} {...extension} rowKey={'id'} />
    {
      open ? (<LaunchPlatformPageModify id={id} open={open} onClose={() => {
        setOpen(false)}} fn={()=>{reloadFn()}} />): null
    }
  </>;
}
